import moment from "moment";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { get, isEmpty, map, size } from "lodash";
import { TargetStatus } from "Components/TargetListing/TargetTabContent/ColumnListing";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import MsgIcon from "Assets/images/comment.svg";
import { Typography, Box } from "@material-ui/core";
import { KENDO_DATE_FORMAT, STATUS, QUESTION_TYPE } from "Constants/index";
import { useSetRecoilState, useRecoilValue } from "recoil";
import {
  checkinDetailsExpandState,
  learningResponseModalState,
  surveyResponseState,
} from "Recoil/Checkins/atom";
import { useStyles } from "./styles";
import CustomColumnMenu from "Components/GridTable/customColumnMenu";
import { headerCell } from "src/utils/kendoGridFilter";
import { UserGeneric } from "Modules/User/UserListing/ColumnListing";
import { useCheckinConstant } from "./useCheckinConstant";
import { ALL_SKILL, MIN_RESIZABLE_WIDTH } from "src/constants";
import { updateOrangeDotHighlightStatus } from "src/hooks/checkin/updateOrangeDotHighlightStatus";

export const useCheckinDetailGrid = () => {
  const classes = useStyles();
  const {  updateIsNewResponseHighlight, updateIsNewRowHighlight } = updateOrangeDotHighlightStatus();

  const responseModal = useSetRecoilState(learningResponseModalState);
  // const surveyReponseDataRecoil = useRecoilValue(surveyResponseState);
  const expanded = useRecoilValue(checkinDetailsExpandState);
  const { getQuestionType } = useCheckinConstant();

  const formatSurveyQuestionWise = (data, count) => {
    return (data || []).map((item, index) => {
      // const dataPresent =
      //   surveyReponseDataRecoil && surveyReponseDataRecoil[index];

      const userAnswers = (item?.userResponse || item?.questionResponse)?.map(
        (item) => ({
          ...item,
          userAnswer: item?.response,
        })
      );
      const useAnswer = userAnswers;
      // dataPresent
      //   ? [
      //       ...(surveyReponseDataRecoil[index]?.userDetail || []),
      //       ...userAnswers,
      //     ]
      //   : userAnswers;
      const userResponse = item?.userResponse || [item?.questionResponse];
      // dataPresent
      //   ? [
      //       ...(surveyReponseDataRecoil[index]?.userResponse || []),
      //       ...(item?.userResponse || [item?.questionResponse]),
      //     ]
      //   : item?.userResponse || [item?.questionResponse];
      const completedUsers = get(item, "completedUsers", "");
      // dataPresent
      //   ? (surveyReponseDataRecoil[index]?.completedUsers || 0) +
      //     get(item, "completedUsers", "")
      //   : get(item, "completedUsers", "");
      const pendingUser = get(item, "totalUsers", "") - get(item, "completedUsers", "");
      const totalUsers = get(item, "completedUsers", "");
      // dataPresent
      //   ? (surveyReponseDataRecoil[index]?.totalUsers || 0) +
      //     get(item, "totalUsers", "")
      //   : get(item, "totalUsers", "");
      const average = get(item, "average", "");
      // dataPresent
      //   ? ((surveyReponseDataRecoil[index]?.average || 0) +
      //       get(item, "average", "")) /
      //     count
      //   : get(item, "average", "");

      return {
        id: index + 1,
        title: get(item, "question", ""),
        dueDate:
          STATUS[get(item, "checkInStatus", "")] === "Completed"
            ? moment(get(item, "dueDate", "")).format(KENDO_DATE_FORMAT)
            : "-",
        status: STATUS[get(item, "status", "")],
        completedUsers,
        pendingUser,
        totalUsers,
        percentage: average || 0,
        type: getQuestionType(get(item, "questionType", ""))?.value || {
          id: "SINGLECHOICE",
          name: "SINGLECHOICE",
          value: "Multiple choice",
        },
        questionType: item?.questionType || "SINGLECHOICE",
        answer: item?.answer,
        userResponse,
        average: average || 0,
        userDetail: useAnswer,
        expanded,
        userResponsePieChart: get(
          item,
          "userResponsePieChart.responseStatistics",
          []
        ),
        options: get(item, "userResponsePieChart.responseStatistics", []),
      };
    });
  };

  const formatSurveyPeopleWise = (data) => {
    return (data?.userCheckinData || []).map((item) => {
      let dateString = moment(get(item, "checkInEndDate", "")).format(
        "YYYY/MM/DD"
      );

      const user = item?.user || item?.rater;
      const firstName = get(user, "firstName", "");
      const lastName = get(user, "lastName", "");
      const userStatus = user?.status;
      const profileImage = get(user, "profileImage.fileName", "");
      let surveyCheckin =
        get(item, "surveyCheckin.surveycheckin", "") ||
        item?.questionResponse?.map((res) => ({
          ...res,
          options: ALL_SKILL,
          userAnswer: [res?.response],
        }));
      const response = map(surveyCheckin, "userAnswer").filter(
        (i) => !isEmpty(i)
      );
      if (surveyCheckin?.[0]?.date) {
        dateString = surveyCheckin?.[0]?.date;
      }
      // dateString = `${moment(dateString).get("year")}/${
      //   moment(dateString).get("month") + 1
      // }/${moment(dateString).get("date")}`;
      if (data.checkInType === "REQUESTFEEDBACK") {
        const data = [];
        if (item?.requestFeedbackAttachments?.length > 0) {
          item?.requestFeedbackAttachments?.map((res) => {
            data.push(res.s3Link);
          });
        }
        if (item?.attachmentLink?.length > 0) {
          item?.attachmentLink.map((item) => {
            data.push(item);
          });
        }
        
        const staticQuestion = [
          {
            __typename: "SurveyItem",
            question: "what feedback would you like to provide?",
            questionType: "DESCRIPTIVE",
            userAnswer: [get(item, "usercomment", "")],
            reqFeedbackAttachments: data,
          },
        ];
        surveyCheckin = [...staticQuestion, ...surveyCheckin];
      }
      
      return {
        id: get(user, "id", ""),
        name: `${firstName} ${lastName}`,
        firstName,
        lastName,
        profileImage,
        expanded,
        isNewRowHighlight: item?.isNewRowHighlight,
        dueDate:
          STATUS[get(item, "checkInStatus", "")] === "Completed"
            ? new Date(dateString)
            : "-",
        percentage: typeof item?.average === "number" ? item?.average : 0,
        status: STATUS[get(item, "checkInStatus", "")],
        surveyCheckin,
        response: `${size(response)}/${size(surveyCheckin)}`,
        completedResponse: size(response),
        userStatus,
        comments: item?.comments,
        score: `${item?.score || 0}%`,
      };
    });
  };

  const formatLearningResponse = (data) => {
    return (data || []).map((item) => {
      let dateString = moment(get(item, "checkInEndDate", ""));
      dateString = `${moment(dateString).get("year")}/${
        moment(dateString).get("month") + 1
      }/${moment(dateString).get("date")}`;

      const firstName = get(item, "user.firstName", "");
      const lastName = get(item, "user.lastName", "");
      const profileImage = get(item, "user.profileImage.fileName", "");
      return {
        ...item,
        //id: get(item, "user.id", ""),
        name: `${firstName} ${lastName}`,
        firstName,
        lastName,
        profileImage,
        dueDate:
          STATUS[get(item, "checkInStatus", "")] === "Completed"
            ? new Date(dateString)
            : "-",
        status: STATUS[get(item, "checkInStatus", "")],
      };
    });
  };
  const surveyDetailsColumns = [
    {
      title: "Title",
      field: "title",
      key: "title",
      show: true,
      filter: "text",
      sortable: true,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      // minWidth: 300
    },
    {
      title: "Questions",
      field: "question",
      key: "question",
      show: true,
      filter: "text",
      sortable: true,
      minWidth: 300,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
    },
    {
      title: "Name",
      field: "name",
      key: "name",
      show: true,
      minWidth: 300,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      filter: "text",
      sortable: true,
    },
    {
      title: "Completed on",
      field: "dueDate",
      key: "dueDate",
      show: true,
      minWidth: 170,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      filter: "date",
      sortable: true,
    },
    {
      title: "Status",
      field: "status",
      key: "status",
      show: true,
      filter: "text",
      minWidth: 150,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      sortable: true,
    },
    {
      title: "Type",
      field: "questionType",
      key: "questionType",
      show: true,
      filter: "text",
      // minWidth: 120,
      sortable: true,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
    },
    {
      title: "Response",
      field: "response",
      key: "response",
      show: true,
      minWidth: 350,
      filter: "text",
      sortable: true,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
    },

    {
      title: "Avg. score",
      field: "percentage",
      key: "percentage",
      show: true,
      filter: "text",
      minWidth: 120,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      sortable: true,
    },
    {
      title: "Score",
      field: "score",
      key: "score",
      show: true,
      filter: "text",
      sortable: true,
      minWidth: 150,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
    },
  ];

  const toggleGridColumns = [
    {
      title: "Name",
      field: "name",
      key: "name",
      minWidth: 220,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      show: true,
      // filter: "text",
      // sortable: false,
    },
    {
      title: "Completed on",
      field: "dueDate",
      key: "dueDate",
      show: true,
      minWidth: 200,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      // filter: "date",
      // sortable: false,
    },
    {
      title: "Response",
      field: "response",
      key: "response",
      show: true,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      // filter: "text",
      // sortable: false,
    },
    {
      title: "Attachments",
      field: "attachments",
      key: "attachments",
      show: true,
      minResizableWidth: MIN_RESIZABLE_WIDTH,
      // filter: "text",
      // sortable: false,
    },
  ];

  const fetchSurveyDetailsColumns = (column, checkInType, data) => {
    let columnObject = { ...column };
    let columnMenu = {
      columnMenu: (props) => (
        <CustomColumnMenu
          {...props}
          columns={columnObject}
          data={data}
          onColumnsSubmit={() => {}}
        />
      ),
    };

    switch (column.field) {
      case "title":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return (
              <td>
                <Typography variant="body2" className="multi-wrap-2 font-13">
                  {`${get(colProps, "dataItem.id")}. ${get(
                    colProps,
                    "dataItem.title"
                  )}`}
                </Typography>
              </td>
            );
          },
        };
        break;
      case "name":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return (
              <td onClick={()=>{ updateIsNewRowHighlight(colProps)} }>
                <Box display="flex" alignItems="center">
                  <UserProfileWidget
                    firstName={get(colProps, "dataItem.firstName")}
                    lastName={get(colProps, "dataItem.lastName")}
                    url={get(colProps, "dataItem.profileImage")}
                  />
                  <Typography
                    variant="body2"
                    className={`${
                      colProps?.dataItem?.userStatus ===
                      ("DEACTIVATED" || "REACTIVATED")
                        ? classes.deactivateUser
                        : ""
                    } font-13`}
                  >
                    {get(colProps, "dataItem.name")}
                  </Typography>
                </Box>
              </td>
            );
          },
        };
        break;
      case "dueDate":
        columnObject = {
          ...column,
          ...columnMenu,
          headerCell: headerCell,
          cell: (colProps) => {
            return (
              <UserGeneric
                title={
                  get(colProps, "dataItem.dueDate", "").toString().length > 1
                    ? moment(get(colProps, "dataItem.dueDate", "")).format(
                        KENDO_DATE_FORMAT
                      )
                    : get(colProps, "dataItem.dueDate", "")
                }
                addtionalClass="text-center"
                onRowClick={()=>{ updateIsNewRowHighlight(colProps)} }
              />
            );
          },
        };
        break;
      case "status":
        columnObject = {
          ...column,
          ...columnMenu,
          headerCell: headerCell,
          cell: (colProps) => {
            return <TargetStatus colProps={colProps} isCheckin={true} />;
          },
        };
        break;
      case "score":
        columnObject = {
          ...column,
          ...columnMenu,
          headerCell: headerCell,
          cell: (colProps) => {
            return (
              <td className="text-center">
                {get(colProps, "dataItem.score") || 0 + "%"}
              </td>
            );
          },
        };
        break;
      case "response":
        columnObject = {
          ...column,
          cell: (colProps) => {
            return checkInType === "SURVEY" ? (
              <td>{`${get(colProps, "dataItem.response")}`}</td>
            ) : (
              <td onClick={()=>{ updateIsNewRowHighlight(colProps)} } >
                <img
                  className={`d-block ${
                    get(colProps, "dataItem.checkInStatus", "") !== "COMPLETE"
                      ? classes.disabledIcon
                      : "cursor-pointer"
                  }`}
                  src={MsgIcon}
                  alt="icon"
                  onClick={() => {
                    get(colProps, "dataItem.checkInStatus", "") ===
                      "COMPLETE" &&
                      responseModal(get(colProps, "dataItem.id", ""));
                      updateIsNewResponseHighlight(colProps);
                  }}
                />
                 {colProps?.dataItem?.isNewResponseHighlight ? (
                     <span className={classes.responseIconNotif}>&nbsp;</span>
                     ) : null }
              </td>
            );
          },
        };
        break;
      case "questionType":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return <td>{get(colProps, "dataItem.type")}</td>;
          },
        };
        break;
      case "percentage":
        columnObject = {
          ...column,
          ...columnMenu,
          headerCell: headerCell,
          cell: (colProps) => {
            return (
              <td className="text-center">
                {get(colProps, "dataItem.percentage")?.toFixed(0) + "%"}
              </td>
            );
          },
        };
        break;
      default:
        columnObject = { ...column };
        break;
    }

    return <Column {...columnObject} width={columnObject.minWidth} />;
  };

  return {
    formatSurveyQuestionWise,
    formatSurveyPeopleWise,
    surveyDetailsColumns,
    toggleGridColumns,
    formatLearningResponse,
    fetchSurveyDetailsColumns,
  };
};
